'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.controller('homeCtrl', function ($scope) {});
  return app;
};

; /**
   * 首页
   */


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/index.ctrl.js
// module id = 46
// module chunks = 0